import { useQuery, type QueryClient } from '@tanstack/react-query';
import { fetchSidebarCounts, type SidebarCounts } from '../services/sidebarCounts';
import { SIDEBAR_COUNTS_KEY } from './queryKeys';

const REFRESH_MS = 60_000;

export interface NavBadgeCounts {
    unreadConversations: number;
    myOpenCases: number;
    dmNotificationPatients: number;
    dmMessagePatients: number;
    pendingCharges: number;
    conversations: SidebarCounts['conversations'] | undefined;
}

// A failed poll keeps the last data; a null count reads as 0, which hides its badge.
export function useSidebarCounts(): NavBadgeCounts {
    const { data } = useQuery({
        queryKey: SIDEBAR_COUNTS_KEY,
        queryFn: fetchSidebarCounts,
        staleTime: REFRESH_MS,
        refetchInterval: REFRESH_MS,
        refetchOnWindowFocus: true
    });
    return {
        unreadConversations: data?.conversations?.unread ?? 0,
        myOpenCases: data?.myCases?.total ?? 0,
        dmNotificationPatients: data?.dmNotifications?.patients ?? 0,
        dmMessagePatients: data?.dmMessages?.patients ?? 0,
        pendingCharges: data?.pendingCharges?.total ?? 0,
        conversations: data?.conversations
    };
}

export function invalidateSidebarCounts(queryClient: QueryClient): Promise<void> {
    return queryClient.invalidateQueries({ queryKey: SIDEBAR_COUNTS_KEY });
}
